/* Pleine Balle — global.js : menu mobile + tiroir panier (AJAX) */
(function () {
  'use strict';

  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var drawer = document.getElementById('CartDrawer');

  function updateCounts(n) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    qsa('[data-cart-bubble]').forEach(function (el) {
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  function renderCart(cart) {
    updateCounts(cart.item_count);
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var sub = drawer.querySelector('[data-cart-subtotal]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Votre panier est vide.</p>';
      if (foot) foot.hidden = true;
      return;
    }

    function esc(str) {
      return String(str).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    body.innerHTML = cart.items.map(function (item) {
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<div class="cd-item__variant">' + item.variant_title + '</div>' : '';
      var props = '';
      if (item.properties) {
        var keys = Object.keys(item.properties).filter(function (k) {
          return k.charAt(0) !== '_' && item.properties[k];
        });
        if (keys.length) {
          props = '<div class="cd-item__props">' + keys.map(function (k) {
            return esc(k) + ' : ' + esc(item.properties[k]);
          }).join('<br>') + '</div>';
        }
      }
      var img = item.image
        ? '<img src="' + item.image + '" alt="" width="64" height="64" loading="lazy">' : '';
      return '<div class="cd-item" data-key="' + item.key + '">' +
          '<a class="cd-item__media" href="' + item.url + '">' + img + '</a>' +
          '<div class="cd-item__info">' +
            '<a class="cd-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
            variant +
            props +
            '<div class="cd-item__row">' +
              '<div class="cd-item__qty">' +
                '<button type="button" class="cd-qty__btn" data-line-minus aria-label="Diminuer">&minus;</button>' +
                '<span class="cd-qty__val">' + item.quantity + '</span>' +
                '<button type="button" class="cd-qty__btn" data-line-plus aria-label="Augmenter">+</button>' +
              '</div>' +
              '<button type="button" class="cd-item__remove" data-line-remove>Retirer</button>' +
              '<div class="cd-item__price">' + money(item.final_line_price) + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    if (sub) sub.textContent = money(cart.total_price);
    if (foot) foot.hidden = false;
  }

  function fetchCart(cb) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (cb) cb(cart); })
      .catch(function () {});
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function addToCart(form) {
    var btn = form.querySelector('[name="add"]');
    if (btn) btn.setAttribute('disabled', '');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) btn.removeAttribute('disabled');
        if (!res.ok) { alert(res.data && res.data.description ? res.data.description : 'Produit indisponible.'); return; }
        fetchCart(function () { openDrawer(); });
      })
      .catch(function () { if (btn) btn.removeAttribute('disabled'); });
  }

  document.addEventListener('click', function (e) {
    // Menu mobile
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.getElementById(toggle.getAttribute('aria-controls'));
      if (nav) {
        var open = nav.hasAttribute('hidden');
        if (open) { nav.removeAttribute('hidden'); } else { nav.setAttribute('hidden', ''); }
        toggle.setAttribute('aria-expanded', String(open));
      }
      return;
    }

    // Ouvrir le tiroir depuis le header
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle) { e.preventDefault(); fetchCart(function () { openDrawer(); }); return; }

    // Fermer
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    // Contrôles d'une ligne du tiroir
    var itemEl = e.target.closest('.cd-item');
    if (itemEl) {
      var key = itemEl.getAttribute('data-key');
      var valEl = itemEl.querySelector('.cd-qty__val');
      var current = parseInt(valEl ? valEl.textContent : '1', 10) || 1;
      if (e.target.closest('[data-line-remove]')) { changeQty(key, 0); return; }
      if (e.target.closest('[data-line-minus]')) { changeQty(key, Math.max(0, current - 1)); return; }
      if (e.target.closest('[data-line-plus]')) { changeQty(key, current + 1); return; }
    }
  });

  // Intercepte l'ajout au panier → AJAX + tiroir
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && (form.matches('form[action$="/cart/add"]') || form.matches('.product__form'))) {
      e.preventDefault();
      addToCart(form);
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); } });
})();
